module.exports = "https://www.gc-pro.gnp.com.mx/ddb4fff9849beba6bda9297e30e59452.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/vin.png
// module id = 8175
// module chunks = 0